import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCairometroComponent } from './simple-icons-cairometro.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCairometroComponent ],
    exports:      [ SimpleIconsCairometroComponent ],
    bootstrap:    []
})
export class SimpleIconsCairometroModule {}
